import React from 'react';
import $ from 'jquery';
const productSlider = require('product-slides');

export default class ProductSlider extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			
		}
	}
	
	render() {
		return(
			<div className="product clearfix" id="product-image-slider"></div>
		)
	}
	
	componentWillReceiveProps(nextProps) {
		if(nextProps.imageGallery.length > 0) {
			$('.product').productSlider({
				imageList: nextProps.imageGallery,
				animate: true,
				scrollable: true
			});
		}
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductDetail/ProductSlides.js